import classNames from 'classnames';
import { forwardRef, SyntheticEvent } from 'react';
import { RadioGroupProps } from 'rsuite/lib/RadioGroup';
import { SortPriceType } from '../../@types/sort';
import { InputBox } from '../InfoInput';
import styles from './CustomHeaderCell.module.scss';

type CustomHeaderCellDataItem = DataItem & {
  sortValue?: string;
  priceType?: SortPriceType;
};

export type CustomHeaderCellContentDataListProps = RadioGroupProps<string> & {
  dataKey: string;
  data?: CustomHeaderCellDataItem[];
  selectedValue?: string;
  onChangeSort?: (dataKey: string, value: string, option?: CustomHeaderCellDataItem) => void;
};

const CustomHeaderCellContentDataList = forwardRef<HTMLDivElement, CustomHeaderCellContentDataListProps>(
  ({ className, dataKey, data = [], selectedValue, onChangeSort, onChange, ...props }, ref) => {
    const handleChange = (value: string, event: SyntheticEvent<HTMLElement>) => {
      const selectedOption = data.find(item => item.value === value);
      onChangeSort?.(dataKey, selectedOption?.sortValue || value, selectedOption);
      onChange?.(value, event);
    };

    return (
      <InputBox.RadioGroup
        {...props}
        ref={ref}
        className={classNames(styles['content-data-list'], className)}
        onChange={handleChange}
        value={selectedValue}
      >
        {data.map(({ value, label }) => (
          <InputBox.Radio key={value} className={styles['content-data-list__item']} value={value}>
            {label}
          </InputBox.Radio>
        ))}
      </InputBox.RadioGroup>
    );
  },
);

CustomHeaderCellContentDataList.displayName = 'CustomHeaderCellContentDataList';

export { CustomHeaderCellContentDataList };
